import { FC } from 'react';
import stepIcon from '../../../Assets/StepIcons/Stop.png';
import { NodeLibraryListItem } from '../../Components/NodeLibraryListItem';
import { NodeTypes, STOP_NODE_DESCRIPTION } from '../../utils';

export const StopNodeLibraryListItem: FC = () => {
    return <NodeLibraryListItem label='Stop' description={STOP_NODE_DESCRIPTION} nodeType={NodeTypes.STOP} imgPath={stepIcon} />
}